
import Vue from "vue";
import { NewWebsitesApiFunc, setAccessToken } from "@/api";
import { Website } from "@/models";
import { deleteWebsiteInCompany } from "@/api/websites-new";
import { EnterpriseAdapterApi } from "@vacancorp/enterprise.adapter.api.vacanservice.com";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";

export type DataType = {
  website?: Website;
};

export default Vue.extend({
  name: "WebsiteDetailScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    BaseSubmitButton,
    BaseCancelButton,
  },

  data(): DataType {
    return {
      website: new Website(),
    };
  },

  computed: {
    passcodeText(): string {
      return this.website?.passcode ? this.website?.passcode : "-";
    },

    useTenantIdPassText(): string {
      return this.website?.useTenantIdPass ? "使用する" : "使用しない";
    },
  },

  mounted() {
    this.getWebsite();
  },

  methods: {
    async getWebsite(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const websiteId = this.$router.currentRoute.params.websiteId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewWebsitesApiFunc().getWebsite(
        companyId,
        websiteId
      );

      if (err != null) {
        this.$handleApiError(err, this.getWebsite);
        return;
      }

      this.website = data;
    },

    async deleteWebsite(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);

      const websiteId = this.$router.currentRoute.params.websiteId;
      setAccessToken(this.$auth.accessToken);

      await deleteWebsiteInCompany(companyId, websiteId);

      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: `company-websites`,
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
